import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'bdg-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss'],
})
export class ExpansionPanelComponent {
  @Input()
  headerTitle: string

  @Input()
  headerSubtitle: string

  @Input()
  headerHeight = '64px'

  @Input()
  toggleIconPosition: 'before' | 'after' = 'after'

  @Input()
  disabled = false

  @Input()
  expanded = false

  @Input()
  loading = false

  @Input()
  fixed = false

  openState: boolean

  @Output()
  openStateChange: EventEmitter<boolean> = new EventEmitter()

  handleToggle(expanded: boolean) {
    this.openState = expanded
    this.openStateChange.emit(this.openState)
  }

  getStyle() {
    return this.fixed ? 'pointer-events: none' : ''
  }
}
